// extracted by mini-css-extract-plugin
export default {"details":"eRNeHGFF2YKO3d9bZsgvQ","details__info-panel":"_5QTwzbvw6pKVdPShe0FZa8","details__spec-container":"_23SC6G9VbviEAMajKyr657"};